const app = {
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: 'myMGverse app report',
		// all titles will be injected into this template
		titleTemplate: '%s | myMGverse app report',
	},
	created() {
		// startup logic goes here
	},
};

export { app };
